import API from 'app/api/index';
import parseResponse from 'app/api/requests/parsers/response';
import { Products } from 'app/api/entities/products';
import logError from 'app/error/logError';

const fetchProducts = externalAccountId =>
  API.Subscription.getProducts({ externalAccountId })
    .then(parseResponse)
    .then(Products)
    .catch(logError);

export { fetchProducts };
